/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@chakra-ui/react';
import { ReactNode } from 'react';

type FormProps = {
  children?: ReactNode;
  id: string;
  onSubmit?: any;
  handleSubmit?: any;
};

export const Form = ({
  children,
  id,
  onSubmit,
  handleSubmit,
  ...rest
}: FormProps) => {
  return (
    <Box as="form" id={id} onSubmit={handleSubmit(onSubmit)} {...rest}>
      {children}
    </Box>
  );
};
